"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const PublicParticipationAvatar_1 = require("../PublicParticipationAvatar");
const BudgetCapacityCard_1 = require("../BudgetCapacityCard/BudgetCapacityCard");
const SocialAccountCard = ({ socialAccount, canSendRequest, budgetCapacity, publicationTypes, onClick, children }) => (React.createElement(BudgetCapacityCard_1.default, { className: 'flex start-xs', budgetCapacity: budgetCapacity, canSendRequest: canSendRequest, onClick: onClick },
    React.createElement(PublicParticipationAvatar_1.default, { socialAccount: socialAccount, publicationTypes: publicationTypes }),
    children));
exports.default = SocialAccountCard;
